export default {"src":"/_next/static/media/set-a-phone.9cb9d778.svg","height":76,"width":88};